import React from 'react';
import { Pagination, Typography } from 'antd';
import Spinner from '../../spinner/Spinner';
import OrderHistoryCard from '../OrderHistoryCard';
import { useOrderHistoryController } from './useOrderHistoryController';
import './orderHistory.scss';

const { Title, Text } = Typography;

const OrderHistory: React.FC = () => {
  const {
    copiedOrderId,
    copyOrderId,
    error,
    imageAndPriceByKey,
    imageErrorByKey,
    imageStatusByKey,
    isWaitingForOrders,
    onPageChange,
    orders,
    page,
    pageSize,
    status,
    total,
  } = useOrderHistoryController();

  return (
    <div className="order-history-container">
      <Title className="order-history-title" level={2}>Order History</Title>
      {isWaitingForOrders && (
        <div className="order-history-state">
          <Spinner />
          <Text type="secondary">Loading your orders...</Text>
        </div>
      )}
      {status === 'failed' && error && (
        <div className="order-history-state">
          <Text type="danger">{error}</Text>
        </div>
      )}
      {status === 'succeeded' && (
        orders.length === 0 ? (
          <div className="order-history-state">
            <Text type="secondary">No orders found.</Text>
          </div>
        ) : (
          <>
            {orders.map((order) => (
              <OrderHistoryCard
                key={order.id}
                order={order}
                isCopied={copiedOrderId === order.id}
                onCopyOrderId={copyOrderId}
                imageAndPriceByKey={imageAndPriceByKey}
                imageStatusByKey={imageStatusByKey}
                imageErrorByKey={imageErrorByKey}
              />
            ))}
            {total > pageSize && (
              <div className="order-history-pagination">
                <Pagination
                  current={page}
                  pageSize={pageSize}
                  total={total}
                  showSizeChanger={false}
                  onChange={onPageChange}
                />
              </div>
            )}
          </>
        )
      )}
    </div>
  );
};

export default OrderHistory;
